// extracted by mini-css-extract-plugin
export default {"templateName":"rj1OB"};